<script setup lang="ts">
  export interface IPosUiSegmentedItem {
    id: string;
    label: string;
    disabled?: boolean;
  }

  const props = withDefaults(
    defineProps<{
      value: string;
      items: IPosUiSegmentedItem[];
      block?: boolean;
      disabled?: boolean;
    }>(),
    {
      block: false,
      disabled: false,
    }
  );

  const emit = defineEmits<{
    (e: 'input', id: string): void;
  }>();

  function select(item: IPosUiSegmentedItem) {
    if (!props.disabled && !item.disabled) emit('input', item.id);
  }
</script>

<template>
  <div class="pos-ui-segmented" :class="{ block }" role="radiogroup">
    <button
      v-for="item in items"
      :key="item.id"
      type="button"
      role="radio"
      class="pos-ui-segmented-option"
      :class="{ 'is-active': item.id === value }"
      :aria-checked="item.id === value ? 'true' : 'false'"
      :disabled="disabled || item.disabled"
      @click="select(item)"
    >
      {{ item.label }}
    </button>
  </div>
</template>

<style scoped lang="scss">
  .pos-ui-segmented {
    @apply tw-inline-flex tw-rounded-lg tw-bg-neutral-100 tw-p-0.5;

    &.block {
      @apply tw-flex tw-w-full;

      .pos-ui-segmented-option {
        @apply tw-flex-1;
      }
    }

    .pos-ui-segmented-option {
      // h-10 options + track padding = 44px total hit area.
      @apply tw-h-10 tw-whitespace-nowrap tw-rounded-md tw-border-0 tw-bg-transparent tw-px-3 tw-text-xs tw-font-medium tw-text-neutral-500 tw-transition-colors;

      &.is-active {
        @apply tw-border tw-border-solid tw-border-neutral-200 tw-bg-surface tw-text-neutral-900 tw-shadow-sm;
      }

      &:focus-visible {
        @apply tw-outline-none tw-ring-2 tw-ring-orange-500/40;
      }

      &:disabled {
        @apply tw-cursor-not-allowed tw-opacity-50;
      }
    }
  }
</style>
